import { render, staticRenderFns } from "./CodeHistory.vue?vue&type=template&id=ba390ec6"
import script from "./CodeHistory.vue?vue&type=script&lang=js"
export * from "./CodeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports